const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME_PATTERN = /^(\d{2}):(\d{2})(?::(\d{2}))?/;

export const parseDateOnlyAsLocalDate = (value?: string | Date | null): Date => {
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (!value) {
    return new Date(Number.NaN);
  }

  const match = String(value).match(DATE_ONLY_PATTERN);

  if (match) {
    const [, year, month, day] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const date = new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const parseEventDateTimeAsLocalDate = (
  value?: string | Date | null,
  fallbackTime = "00:00"
): Date => {
  if (value instanceof Date) {
    return new Date(value);
  }

  if (!value) {
    return new Date(Number.NaN);
  }

  const stringValue = String(value);
  const dateOnlyMatch = stringValue.match(DATE_ONLY_PATTERN);

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    const [, hour = "00", minute = "00", second = "00"] = fallbackTime.match(TIME_PATTERN) || [];
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second)
    );
  }

  return new Date(stringValue);
};

export const formatDateTimeForForm = (
  value?: string | Date | null,
  fallbackTime?: string
): string | undefined => {
  if (!value) return undefined;

  const stringValue = String(value);
  const midnightUtcMatch = stringValue.match(/^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.000)?Z$/);
  if (midnightUtcMatch) {
    return `${midnightUtcMatch[1]}T${fallbackTime || "00:00"}:00`;
  }

  const date = new Date(value);
  if (!isValidDate(date)) return undefined;

  return date.toISOString();
};

export const isValidDate = (date: Date): boolean => !Number.isNaN(date.valueOf());

export const formatTimeFromDate = (date: Date): string =>
  `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;

export const todayAsLocalDate = (): Date => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
